/* eslint-disable no-console */
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from '@/state/store'
import routes from './routes'

window.langDate = {
  "night": "Đêm",
  "nights": "Ngày",
  "week": "Tuần",
  "weeks": "Tuần",
  "day-names": ["CN", "T2", "T3", "T5", "T5", "T6", "T7"],
  "check-in": "Bắt đầu",
  "check-out": "Kết thúc",
  "month-names": [
      "Tháng 1",
      "Tháng 2",
      "Tháng 3",
      "Tháng 4",
      "Tháng 5",
      "Tháng 6",
      "Tháng 7",
      "Tháng 8",
      "Tháng 9",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12",
  ],
  "tooltip": {
      "halfDayCheckIn": "Available CheckIn",
      "halfDayCheckOut": "Available CheckOut",
      "saturdayToSaturday": "Only Saturday to Saturday",
      "sundayToSunday": "Only Sunday to Sunday",
      "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
  },
}
Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({routes,mode: 'history',scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

const SSO_DOMAIN_MAP = {
  'pos.tga.com.vn': 'one.tga.com.vn',
  'pos-sandbox.tga.com.vn': 'one-demo.tga.com.vn',
};

function hasSsoSupport() {
  return !!SSO_DOMAIN_MAP[window.location.hostname];
}

function redirectToOneLogin() {
  const oneHost = SSO_DOMAIN_MAP[window.location.hostname];
  if (!oneHost) return false;
  window.location.href = 'https://' + oneHost;
  return true;
}

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/register', '/forgot-password'];
  const authpage = publicPages.includes(routeTo.path);
  let loggedIn = store.getters['auth/loggedIn'];

  if (authpage) {
    if (loggedIn) { next('/'); return; }
    // /login: thử SSO trước, chỉ hiện form khi thực sự không có session ONE
    if (routeTo.path === '/login' && hasSsoSupport()) {
      return store.dispatch('auth/ssoCheck').then((result) => {
        if (result && typeof result === 'object') { next('/'); return; }
        if (result === 'no_session' && redirectToOneLogin()) return;
        next();
      }).catch(() => { next(); });
    }
    next();
    return false;
  }

  if (loggedIn) {
    return store.dispatch('auth/validate').then((validUser) => {
      if (validUser) { next(); return; }
      if (!hasSsoSupport()) { next('/login'); return; }
      return store.dispatch('auth/ssoCheck').then((result) => {
        if (result && typeof result === 'object') { next(); return; }
        if (result === 'no_session' && redirectToOneLogin()) return;
        next('/login');
      }).catch(() => { next('/login'); });
    });
  }

  // Not logged in - passive check ONE cookie first (only on SSO-supported domains)
  if (!hasSsoSupport()) { next('/login'); return; }
  return store.dispatch('auth/ssoCheck').then((result) => {
    if (result && typeof result === 'object') { next(); return; }
    if (result === 'no_session' && redirectToOneLogin()) return;
    next('/login');
  }).catch(() => { next('/login'); });
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
